import { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context/User/UserContext';
import { getJobCategory, getTrainingTrack } from '../_api';
import { JobCategoryDTO, SearchResult } from '../_classes';
import { TRAINING_TRACK_MAX } from '../_const';
import PageWithBreadcrumbs from '../layouts/PageWithBreadcrumbs';
import JobCategoryForm from './FormView';

/**
 * Epic Job Category Form for creating new or editing existing job categories
 * @param {any} props properties from router
 * @returns Job Category Editor page view
 */
const EditorView = props => {
	const query = new URLSearchParams(props.location.search);
	const id = query.get('id');
	const isNew = !!!id;
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const maintenanceUser = contextUser?.userInfo?.impersonationProfile
		? { ...contextUser?.userInfo?.impersonationProfile }
		: { ...contextUser.userInfo.userProfile };

	const [sJobCategory, setJobCategory] = useState(null);

	useEffect(() => {
		let active = true;

		async function fetchApi() {
			//fetch the base job category info
			const selectedJobCategory = await getJobCategory(id);

			//fetch/set training tracks
			for (let i = 1; i <= TRAINING_TRACK_MAX; i++) {
				if (
					selectedJobCategory['trainingTrack' + i] &&
					typeof selectedJobCategory['trainingTrack' + i] === 'number'
				) {
					const trainingTrackDetails = await getTrainingTrack(
						selectedJobCategory['trainingTrack' + i]
					);
					if (trainingTrackDetails) {
						selectedJobCategory.setTrainingTrack(
							i,
							new SearchResult({
								Key: trainingTrackDetails?.trainingTrackID,
								Value: trainingTrackDetails?.name,
							})
						);
					} else {
						selectedJobCategory.setTrainingTrack(i, null);
					}
				}
			}

			//set the state
			setJobCategory(selectedJobCategory);
		}

		if (active && id) {
			fetchApi();
		}
		if (active && !id) {
			setJobCategory(new JobCategoryDTO());
		}

		return () => {
			active = false;
		};
	}, [id]);

	return (
		<PageWithBreadcrumbs
			currentPageLabel={
				isNew ? 'New Job Category' : 'Job Category Editor'
			}
		>
			{(isNew || sJobCategory) && (
				<JobCategoryForm
					jobCategory={sJobCategory}
					isNew={isNew}
					maintenanceInformation={maintenanceUser}
				/>
			)}
		</PageWithBreadcrumbs>
	);
};

export default EditorView;
